import React, { useContext } from "react";
import styled from "styled-components";
import { CreditsContext } from "@stores/CreditsContext";
import CreditsCard from "./credits.card";
import creditsCards from "./credits.config";

const debug = false;
const HeaderCredits = () => {
  const { creditsInfo } = useContext(CreditsContext);
  debug && console.log("HeaderCredits | {creditsInfo}", creditsInfo);

  return (
    <Cards>
      {creditsCards.map((card, cardId) => {
        return (
          <CardContainer key={`container_${cardId}`}>
            <CreditsCard key={cardId} card={card} values={creditsInfo} />
          </CardContainer>
        )
      })}
    </Cards>
  );
};

export default HeaderCredits;

const Cards = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100vw - 80px);
  height: 120px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const CardContainer = styled.div`
  display: flex;
  width: calc(25% - 10px);
  min-width: 200px;
`;
